import React, { FC } from 'react'

export const NotFound: FC = () => <div>404</div>
